// src/lib/electricityContexts.js
export function buildElectricityContexts(totalTWh, {
  population = 67_000_000,         // people
  households = 28_000_000,         // homes
  avgHouseholdKWhPerYear = 2700,   // Ofgem Typical Domestic Consumption
  kWhPerToastSlice = 0.02,
  kWhPerKettleBoil = 0.125,
} = {}) {
  const kWhPerYear = totalTWh * 1e9; // 1 TWh = 1e9 kWh

  // Years of powering all UK households at today’s average consumption
  const householdDemandTWhPerYear = (households * avgHouseholdKWhPerYear) / 1e9;
  const ukHouseholdsYears =
    householdDemandTWhPerYear > 0 ? totalTWh / householdDemandTWhPerYear : 0;

  // Slices of toast per person per day
  const toastSlicesPerPersonPerDay =
    (kWhPerYear / kWhPerToastSlice) / (population * 365);

  // Kettles boiled per person per day
  const kettleBoilsPerPersonPerDay =
    (kWhPerYear / kWhPerKettleBoil) / (population * 365);

  return {
    ukHouseholdsYears,
    toastSlicesPerPersonPerDay,
    kettleBoilsPerPersonPerDay,
  };
}

